import React, { useEffect } from 'react'

export default function SsoSignIn_MD_App() {
  useEffect(() => {
    window.location.replace(import.meta.env.VITE_REACT_APP_PEPSICO_SIGNIN_APP)
  }, [])

  return <></>
}
